var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-0 shortName-letters"},[_vm._v(_vm._s(_vm.shortName))])
}
var staticRenderFns = []

export { render, staticRenderFns }